<template>
    <div>
        <div class="d-flex justify-content-between mb-2">
            <h3 class="card-title">Lista de solicitud de domiciliación Anexo D</h3>
            <div class="d-flex">
                <PrimaryButton class="btn btn-primary ms-auto" data-toggle="modal" data-target="#directDebitModal"
                    @click="directDebitStore.openModal">
                    Generar
                </PrimaryButton>
            </div>
        </div>

        <div class="d-flex mt-3 mb-3">
            <input type="text" class="form-control" placeholder="Buscar Anexo D..."
                v-model="directDebitStore.searchString" />
        </div>

        <div>
            <DirectDebitRequestTable :directDebitRequestData="directDebitStore.paginatedS"
                @sort="directDebitStore.sortBy($event)" @edit="directDebitStore.editData($event)" />
            <Pagination v-if="directDebitStore.filteredS.length > directDebitStore.itemsPerPage"
                :list="directDebitStore.filteredS" :items-per-page="directDebitStore.itemsPerPage"
                :current-page="directDebitStore.currentPage" @current-page="directDebitStore.setCurrentPage($event)" />
        </div>
        <!--:customClass="'modal-xl'"-->
        <Modal modal-id="directDebitModal">
            <div class="modal-header">
                <h4 class="modal-title">Solicitud de domiciliación Anexo D</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="directDebitStore.closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="col-12 col-md-3 col-lg-3 content-col">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">Solicitud:</label>
                            </div>

                            <div class="col-12 col-md-4 col-lg-4" v-show="!directDebitStore.isEdit">
                                <select id="applicationSelectDD" v-model="directDebitStore.selectedApplication"
                                    class="form-select selectpicker border-dark" data-width="100%"
                                    data-live-search="true"
                                    :disabled="!directDebitStore.loanApplicationsOptions.length && directDebitStore.loanApplicationsOptions.loanApplication !== null"
                                    title="Selecciona solicitud...">
                                    <option value="" disabled>Selecciona solicitud</option>
                                    <option v-for="application in directDebitStore.loanApplicationsOptions"
                                        :key="application.loanApplication?.id" :value="application">
                                        {{ application.loanApplication?.referenceNumber }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4" v-show="directDebitStore.isEdit">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">
                                    {{ directDebitStore?.form?.loanApplication?.referenceNumber || '' }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <DirectDebit />
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="directDebitStore.closeModal">
                    {{ $getLocaleMessage('buttons', 'cancel') }}
                </button>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import { onMounted, nextTick, computed, watch } from "vue";
import { useDirectDebitStore } from "@/pinia/LoanApplications/Legal/useDirectDebitStore.module";
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import DirectDebit from '@/Components/Forms/LoanApplications/Legal/DirectDebit.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';
import DirectDebitRequestTable from "@/Components/Tables/DirectDebitRequestTable.vue";

const directDebitStore = useDirectDebitStore();
const getSelectDD = () => $('#applicationSelectDD');

//Inicializa el selectpicker
const initializeSelectPicker = () => {
    nextTick(() => {
        const select = getSelectDD();
        if (select.length) {
            select.selectpicker('refresh');
            if (!directDebitStore.selectedApplication) {
                select.selectpicker('val', '');
            }
        }
    });
};

// Watcher para isModalOpen
watch(
    () => directDebitStore.isModalOpen,
    (newValue) => {
        if (!newValue) {
            initializeSelectPicker();
        }
    },
);

// Watcher para las opciones del select
watch(
    () => directDebitStore.loanApplicationsOptions,
    async (newOptions) => {
        if (newOptions.length > 0 && directDebitStore.isModalOpen) {
            initializeSelectPicker();
        }
    },
    { deep: true }
);

// Watcher para actualizar datos cuando cambia selectedApplication
watch(
    () => directDebitStore.selectedApplication,
    (newApp) => {

        if (!directDebitStore.isEdit) {
            directDebitStore.form = {};
        }

        if (newApp) {
            directDebitStore.form = newApp;
        }
    },
    { deep: true, immediate: true } // Agrega esto para que se ejecute al montar el componente immediate
);

// Cargar data al montar el componente
onMounted(async () => {
    //Cargar data de opciones de solicitud
    await directDebitStore.getLoanApplication();
    //Cargar los datos de la tabla
    await directDebitStore.fetchAnexo();
    //Inicializar el componente de selector
    initializeSelectPicker();
});
</script>